import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteActionItemMutationVariables = Types.Exact<{
  data: Types.DeleteActionItemInput;
}>;


export type DeleteActionItemMutation = { deleteActionItem?: { success?: boolean | null, actionItems?: Array<{ id: string, totalTimeSpent?: number | null }> | null } | null };


export const DeleteActionItemDocument = /*#__PURE__*/ gql`
    mutation deleteActionItem($data: DeleteActionItemInput!) {
  deleteActionItem(data: $data) {
    success
    actionItems {
      id
      totalTimeSpent
    }
  }
}
    `;

export function useDeleteActionItemMutation() {
  return Urql.useMutation<DeleteActionItemMutation, DeleteActionItemMutationVariables>(DeleteActionItemDocument);
};